import {useSelector} from 'react-redux';
import Selector from '../../../selectors/pages/lootbox/header';
import Diamond from './diamond';
import {navigate} from '../../../utils/navigation';

export default () => {
    const {box, user} = useSelector(Selector)

    return (
        <div className="loot-header">
            <div className="back" onClick={e => navigate('/tasks')}> 
                <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.00003 16.92L1.48003 10.4C0.710027 9.63002 0.710027 8.37002 1.48003 7.60002L8.00003 1.08002" stroke="#b0b0b0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                Back
            </div>
            <div className="title">{box.name}</div>
            <div className="shop-balance">
                <Diamond />
                {user.diamonds}
            </div>
        </div>
    )
}